import React from 'react';
import { ShieldCheck, Star } from 'lucide-react';
import { CTAButton } from './ui/CTAButton';
export function Hero() {
  return <section className="pt-24 pb-12 px-4 bg-slate-50 border-b border-slate-200" data-id="element-70">
      <div className="max-w-4xl mx-auto" data-id="element-71">
        <div className="flex flex-col items-center text-center mb-8" data-id="element-72">
          <div className="inline-flex items-center gap-1.5 bg-red-100 text-red-700 px-3 py-1 rounded-full text-sm font-bold mb-6 border border-red-200" data-id="element-73">
            <span className="relative flex h-2.5 w-2.5" data-id="element-74">
              <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-red-400 opacity-75" data-id="element-75"></span>
              <span className="relative inline-flex rounded-full h-2.5 w-2.5 bg-red-600" data-id="element-76"></span>
            </span>
            OFERTA DE HOY: 78% DE DESCUENTO
          </div>

          <h1 className="text-4xl md:text-5xl lg:text-6xl font-extrabold text-slate-900 tracking-tight mb-6 leading-tight" data-id="element-77">
            Protocolo 7 Días Sin Reinfestación:{' '}
            <br className="hidden md:block" data-id="element-78" />
            <span className="text-teal-600" data-id="element-79">
              El Método MIC para Eliminar Piojos en Casa y Evitar que Regresen
            </span>
          </h1>

          <h2 className="text-lg md:text-xl text-slate-600 font-medium max-w-3xl leading-relaxed mb-8" data-id="element-80">
            Elimina piojos y liendres de raíz, rompe el ciclo de eclosión y
            evita que el problema regrese a casa el próximo lunes.
          </h2>

          <div className="flex items-center gap-1 text-amber-400 mb-8" data-id="element-81">
            {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-current" data-id="element-82" />)}
            <span className="text-slate-600 text-sm font-medium ml-2" data-id="element-83">
              +4,200 familias libres de piojos
            </span>
          </div>
        </div>

        <div className="grid md:grid-cols-2 gap-8 items-center bg-white p-6 md:p-8 rounded-2xl shadow-xl border border-slate-100" data-id="element-84">
          <div className="relative" data-id="element-85">
            <div className="absolute inset-0 bg-teal-100 rounded-full blur-3xl opacity-50" data-id="element-86"></div>
            <img src="https://cdn.magicpatterns.com/uploads/qbAAMSvFGiSERToAj4RmuJ/PIOJOS.png" alt="Protocolo 7 Días Sin Reinfestación en múltiples dispositivos" className="relative z-10 w-full h-auto object-contain drop-shadow-2xl" data-id="element-87" />
          </div>

          <div className="flex flex-col justify-center" data-id="element-88">
            <div className="mb-6" data-id="element-89">
              <div className="flex items-center gap-2 mb-2" data-id="element-90">
                <ShieldCheck className="w-6 h-6 text-teal-600" data-id="element-91" />
                <span className="text-teal-800 font-bold uppercase tracking-wider text-sm" data-id="element-92">
                  Descarga Digital Inmediata
                </span>
              </div>
              <div className="flex items-baseline gap-2 mb-2" data-id="element-93">
                <span className="text-5xl font-black text-slate-900" data-id="element-94">
                  $6.39
                </span>
                <span className="text-lg text-slate-500 font-medium" data-id="element-95">USD</span>
                <span className="text-lg text-slate-400 line-through ml-2" data-id="element-96">
                  $29.00
                </span>
              </div>
              <p className="text-sm text-slate-500" data-id="element-97">
                Pago único. Sin suscripciones.
              </p>
            </div>

            <CTAButton fullWidth data-id="element-98" />
          </div>
        </div>
      </div>
    </section>;
}